module.exports = __webpack_public_path__ + "static/media/alltech-connect-logo2.6c33dad9.svg";